import React, { useMemo } from 'react';
import { formatGoalsPromptPreview } from '../utils/formatGoalsPromptPreview';

export default function GoalsPromptPreview({ tiers, lookup = {} }) {
  const text = useMemo(() => formatGoalsPromptPreview(tiers, lookup), [tiers, lookup]);

  return (
    <div className="rounded-xl border border-iron-border bg-iron-surface px-3 py-3">
      <p className="mb-2 font-mono text-[9px] uppercase tracking-wider text-iron-muted">
        Como a IA vai ler isto
      </p>
      <pre className="whitespace-pre-wrap font-mono text-[10px] leading-relaxed text-iron-muted-strong">
        {text}
      </pre>
    </div>
  );
}
